import type { ErrorBoundaryProps } from '@sentry/react';
import { ErrorBoundary } from '@sentry/react';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { handleError } from '../../blocks/Error';
import Footer from '../../blocks/Footer';
import Loader from '../../common/Loader';

const beforeCapture: ErrorBoundaryProps['beforeCapture'] = scope => {
    scope.setTag('boundary', 'CenteredLayout');
};

const CenteredLayout = () => (
    <div className="flex h-screen flex-col">
        <div className="flex flex-1 items-center justify-center">
            <ErrorBoundary beforeCapture={beforeCapture} fallback={handleError}>
                <Suspense fallback={<Loader />}>
                    <Outlet />
                </Suspense>
            </ErrorBoundary>
        </div>
        <Footer layoutStyle="CenteredLayout" />
    </div>
);

export default CenteredLayout;
